import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from '../../Components/Loader';


function AttendanceDetailsStudent() {
    const { userId } = useParams();
    const [attendanceData, setAttendanceData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        console.log("Fetching attendance data for userId:", userId);  // Log the userId
        const fetchAttendanceData = async () => {
            setLoading(true);
            setError(null);
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    setError("No authentication token found.");
                    return;
                }

                const response = await axios.get(`https://api.uniums.com/api/admin/student-attendance/${userId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                setAttendanceData(response.data.data || []);
            } catch (error) {
                console.error("Error fetching attendance data:", error);
                setError("Error fetching attendance data.");
            } finally {
                setLoading(false);
            }
        };

        fetchAttendanceData();
    }, [userId]);

    // Function to generate a 12-month calendar table for student attendance
    const generateCalendar = () => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June', 
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        // Mapping attendance data to a date string for quick lookup
        const attendanceMap = {};
        attendanceData.forEach(record => {
            const date = new Date(record.date);
            const dateString = date.toLocaleDateString();
            attendanceMap[dateString] = record; // Save full record for each date
        });

        const getDayStatus = (day, month) => {
            const date = new Date(2025, month, day); // Using 2025 as the year
            const dateString = date.toLocaleDateString();
            return attendanceMap[dateString] || null; // If no data, return null
        };

        // Create calendar for each month
        return months.map((month, monthIndex) => {
            const daysInMonth = new Date(2025, monthIndex + 1, 0).getDate(); // Get number of days in the month
            const weeks = [];
            let currentWeek = [];

            for (let day = 1; day <= daysInMonth; day++) {
                const dayData = getDayStatus(day, monthIndex);
                let statusContent = 'No Data';
                let classNames = 'no-data';
                
                if (dayData) {
                    statusContent = dayData.status === 'Present' ? 'Present' : 'Absent';
                    classNames = dayData.status === 'Present' ? 'present' : 'absent';
                }

                currentWeek.push(
                    <td key={day} className={classNames}>
                        {day}<br />
                        {statusContent}
                        {dayData && dayData.status === 'Present' && (
                            <div>
                                <strong>Class:</strong> {dayData.class}<br />
                                <strong>Subject:</strong> {dayData.subject}<br />
                                <strong>Employee Code:</strong> {dayData.employeeCode}<br />
                            </div>
                        )}
                    </td>
                );
                
                if (currentWeek.length === 7 || day === daysInMonth) {
                    weeks.push(<tr key={day}>{currentWeek}</tr>);
                    currentWeek = [];
                }
            }

            return (
                <div key={month}>
                    <h3>{month}</h3>
                    <div className="attendance-table-legend">
                    <table border="1" className="attendance-table-attendance">
                        <thead>
                            <tr>
                                <th>Sun</th>
                                <th>Mon</th>
                                <th>Tue</th>
                                <th>Wed</th>
                                <th>Thu</th>
                                <th>Fri</th>
                                <th>Sat</th>
                            </tr>
                        </thead>
                        <tbody>{weeks}</tbody>
                    </table>
                    </div>
                </div>
            );
        });
    };

    return (
        <div className="attendance-month">
            <h1>Attendance History Of {new Date().getFullYear()}</h1>
            {loading ? (
                <Loader />
            ) : error ? (
                <p>{error}</p>
            ) : (
                <div>
                    {generateCalendar()}
                </div>
            )}
        </div>
    );
}

export default AttendanceDetailsStudent;
